"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["color", "size"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var GameConsole = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var {
    color,
    size
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("style", null, ".a{fill:none;}.b{fill:#4a4a4a;}")), /*#__PURE__*/_react.default.createElement("defs", null), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(208 -52)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    className: "a",
    width: "16",
    height: "16",
    transform: "translate(-208 52)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M-203.245,68a2.731,2.731,0,0,1-.717-.1,2.8,2.8,0,0,1-1.944-3.413l1.165-4.421a2.764,2.764,0,0,1,1.3-1.7,2.7,2.7,0,0,1,2.074-.269,2.762,2.762,0,0,1,1.721,1.4h1.3a2.76,2.76,0,0,1,1.72-1.4,2.7,2.7,0,0,1,2.075.269,2.766,2.766,0,0,1,1.3,1.7l1.165,4.421a2.8,2.8,0,0,1-1.943,3.413,2.707,2.707,0,0,1-2.074-.27,2.764,2.764,0,0,1-1.3-1.7l-.114-.43h-2.956l-.114.43a2.764,2.764,0,0,1-1.3,1.7A2.71,2.71,0,0,1-203.245,68Zm1.158-9a1.713,1.713,0,0,0-.859.232,1.77,1.77,0,0,0-.829,1.092l-1.165,4.421a1.8,1.8,0,0,0,1.24,2.193,1.705,1.705,0,0,0,1.311-.171,1.769,1.769,0,0,0,.829-1.092l.309-1.176h4.5l.31,1.176a1.77,1.77,0,0,0,.829,1.092,1.7,1.7,0,0,0,1.311.171,1.794,1.794,0,0,0,1.239-2.193l-1.165-4.421a1.773,1.773,0,0,0-.829-1.093,1.712,1.712,0,0,0-1.312-.171,1.769,1.769,0,0,0-1.187,1.109l-.12.33h-2.652l-.12-.33a1.768,1.768,0,0,0-1.187-1.109A1.734,1.734,0,0,0-202.087,59Z",
    transform: "translate(-1 -2.999)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M-199.005,66a1,1,0,0,1-1-1,1,1,0,0,1,1-1,1,1,0,0,1,1,1A1,1,0,0,1-199.005,66Zm0-1h0Z",
    transform: "translate(-3.997 -6)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M.5,0A.5.5,0,1,1,0,.5.5.5,0,0,1,.5,0Z",
    transform: "translate(-197.5 57.5)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M.5,0A.5.5,0,1,1,0,.5.5.5,0,0,1,.5,0Z",
    transform: "translate(-197.5 59.5)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M.5,0A.5.5,0,1,1,0,.5.5.5,0,0,1,.5,0Z",
    transform: "translate(-198.5 58.5)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M.5,0A.5.5,0,1,1,0,.5.5.5,0,0,1,.5,0Z",
    transform: "translate(-196.5 58.5)"
  })));
});
GameConsole.propTypes = {
  color: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onClick: _propTypes.default.func
};
GameConsole.defaultProps = {
  color: 'currentColor',
  size: '1em',
  onClick: () => {}
};
var _default = GameConsole;
exports.default = _default;